import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AccountSplitResource, ClientApi, ManagementFeesAccountSplitsResource } from 'src/app/client-api.service';
import { ManagementFeeAccountSplitsComponent } from '../management-fee-account-splits/management-fee-account-splits.component';

@Injectable({
  providedIn: 'root'
})
export class AccountSplitService {
  
  private accountSplits = new BehaviorSubject<AccountSplitResource[]>([]);
  readonly accountSplits$ = this.accountSplits.asObservable();

  private closeMgntFeesListSubject = new Subject<string>();
  readonly closeMgntFeesListSubject$ = this.closeMgntFeesListSubject.asObservable();

  private managementFeeAccountSplits = new BehaviorSubject<ManagementFeesAccountSplitsResource[]>([]);
  readonly ManagementFeeAccountSplits$ = this.managementFeeAccountSplits.asObservable();
  
  constructor(private apiClient: ClientApi) {

  }

  // Accounts Splits
  deleteAccountSplit(id: number) {
    return this.apiClient.deleteAccountSplit(id);
  }

  setAccountSplits() {
    this.getAccountSplits().subscribe(res => this.accountSplits.next(res));
  }

  getAccountSplits() {
    return this.apiClient.getAccountSplits().pipe();
  }

  putAccountSplit(accountSplitResource: AccountSplitResource) {
    return this.apiClient.putAccountSplit(accountSplitResource);
  }

  refreshAccountSplit() {
    this.setAccountSplits();
  }

  closeMgntFeesAccountSplitsList() {
    this.closeMgntFeesListSubject.next('close');
  }

  // Management Fee Account Splits
  deleteManagementFeeAccountSplit(orgCode: string, accountSplitId: number) {    
    return this.apiClient.deleteManagementFeeAccountSplit(orgCode, accountSplitId);
  }

  setManagementFeeAccountSplits() {
    this.getManagementFeeAccountSplits().subscribe(res => this.managementFeeAccountSplits.next(res));
  }

  getManagementFeeAccountSplits() {
    return this.apiClient.getManagementFeeAccountSplits();
  }

  putManagementFeeAccountSplit(managementFeesAccountSplitsResource: ManagementFeesAccountSplitsResource) {
    return this.apiClient.putManagementFeeAccountSplit(managementFeesAccountSplitsResource);
  }

  refreshManagementFeeAccountSplit() {
    this.setManagementFeeAccountSplits();
  }
  
}

export class ManagementFeesAccountSplit implements ManagementFeesAccountSplitsResource {
  orgCode: string = '';
  accountSplitId: number = 0;
}

export class ManagementFeeAccountSplit {
  orgCode: string = '';
  accountSplitid: number = 0;
  name: string = '';
  type: string = '';
  splitOrgCode: string = '';
  splitaccount: string = '';
  splitpercentage: number = 0;
}